<template>
    <div>
        <div class="lke-bg">
            <div class="lke-top">
                <div class="lke-top-l">您现在所在的位置：我的课程</div>
                <div class="lke-top-r"  @click="openRouter('indexPage')">返回首页
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>
            <div class="lke-mid">
                <!-- <div class="lke-mid-top">
                    <i class="el-icon-s-order"></i>
                    学习状态
                </div>
                <div class="lke-mid-fot" v-loading="listLoading">
                    <div class="lke-tab1in">
                       <div class="lke-tab1in-top">
                           <i class="el-icon-star-on"></i>
                           课程进度
                       </div>
                       <div class="lke-tab1in-fot">
                           <span>全部课程</span>
                           <div>
                               <el-progress :percentage="Math.round(completeness*100)"></el-progress>
                           </div>
                       </div>
                   </div>
                   <div class="lke-tab1in">
                       <div class="lke-tab1in-top">
                           <i class="el-icon-star-on"></i>
                           自测情况
                       </div>
                       <div class="lke-tab1in-fot">
                           <span>课程自测</span>
                           <div>
                               <el-progress :percentage="50"></el-progress>
                           </div>
                       </div>
                   </div>
                </div> -->
            </div>
            <div class="lke-fot" v-loading="listLoading">
                <el-tabs v-model="activeName">
                    <el-tab-pane :label="tab.name" :name="tab._id" v-for="(tab,index) in typelist" :key="index">
                        <template>
                            <el-table
                            :data="tab.course"
                            style="width: 100%">
                            <el-table-column
                                prop="name"
                                label="课程名称">
                            </el-table-column>
                            <el-table-column
                                label="课程类别"
                                width="140">
                                <template slot-scope="{row}">
                                <span>{{ tab.name}}</span>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column
                                label="进度"
                                width="200">
                                <template slot-scope="{row}">
                                    <div style="padding-right: 20px">
                                        <el-progress :percentage="Math.round(row.completeness*100)"></el-progress>
                                    </div>
                                </template>
                            </el-table-column> -->
                            <el-table-column
                                label="进入学习"
                                width="180">
                                <template slot-scope="{row}">
                                    <a target="_blank" :href="'/learnspace.html#?courseid=' + row._id">
                                        <el-button size="small" type="primary">进入学习</el-button>
                                    </a>
                                </template>
                            </el-table-column>
                            </el-table>
                        </template>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import { getcourselist } from "@/api/index"
export default {
    props: {

    },
    data() {
        return {
            typelist: [],
            activeName: '',
            listLoading: false,
            completeness: 0,
        };
    },
    filters: {
        type(val) {
            if (val.length > 0) {
                return val[0].name
            } else {
                return ''
            }
        },
    },
    computed: {
        courseList() {
            return this.$store.state.courseList;
        },
    },
    created() {
        this.getcourse();
    },
    mounted() {
        
    },
    watch: {

    },
    methods: {

        openRouter(val){
             this.$router.push({ name: val });
        },

        getcourse() { //获取教程信息
            this.listLoading = true;
            setTimeout(() => {
                if (this.courseList) {
                    let typelist = [];
                    for (let index = 0; index < this.courseList.courseType.length; index++) {
                        this.courseList.courseType[index].course = []
                        for (let i = 0; i < this.courseList.course.length; i++) {
                            if (this.courseList.courseType[index]._id === this.courseList.course[i].courseType) {
                                this.courseList.courseType[index].course.push(this.courseList.course[i])
                            }
                        }
                    }
                    for (let index = 0; index < this.courseList.courseType.length; index++) {
                        if (this.courseList.courseType[index].course.length > 0) {
                            typelist.push(this.courseList.courseType[index])
                        }
                    }
                    for (let index = 0; index < typelist.length; index++) {
                        if (index === 0) {
                            this.activeName = typelist[index]._id
                        }
                    }
                    this.completeness = this.courseList.completeness
                    this.typelist = typelist;
                    this.listLoading = false;
                } else {
                    getcourselist().then(response =>{
                    this.$store.commit("courseList", response);
                    let typelist = [];
                    for (let index = 0; index < response.courseType.length; index++) {
                        response.courseType[index].course = []
                        for (let i = 0; i < response.course.length; i++) {
                            if (response.courseType[index]._id === response.course[i].courseType) {
                                response.courseType[index].course.push(response.course[i])
                            }
                        }
                    }
                    for (let index = 0; index < response.courseType.length; index++) {
                        if (response.courseType[index].course.length > 0) {
                            typelist.push(response.courseType[index])
                        }
                    }
                    for (let index = 0; index < typelist.length; index++) {
                        if (index === 0) {
                            this.activeName = typelist[index]._id
                        }
                    }
                    this.completeness = response.completeness
                    this.typelist = typelist;
                    this.listLoading = false;
            })
                }
            }, 500);
        },

    },
    components: {

    },
};
</script>

<style>
.el-tabs__item{
    font-size: 18px;
    letter-spacing: 1px;
}
.el-tabs__item.is-active{
    font-weight: 600;
}
</style>

<style scoped>
.lke-bg{
    width: 1024px;
    margin: 0 auto;
}
.lke-top{
    width: 1024px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
}
.lke-top-l{
    font-size: 16px;
    padding-left: 20px;
}
.lke-top-r{
    font-size: 16px;
    padding-right: 20px;
    cursor: pointer;
}
.lke-top-r:hover{
    color: #409EFF;
}
.lke-mid{
    border: 1px solid #ccc;
    width: 1024px;
    margin-bottom: 20px;
}
.lke-mid-top{
    padding: 10px 20px;
    font-size: 18px;
    color: #409EFF;
    display: flex;
    align-items: center;
    font-weight: bold;
    border-bottom: 1px solid #ccc;
    background: #F7F7F7;
}
.lke-mid-top > i{
    font-size: 30px;
    padding-right: 20px;
}
.lke-mid-fot{
    padding: 20px 50px 20px 20px;
}
.lke-tab1in-top > i{
    font-size: 18px;
    color: #409EFF;
}
.lke-tab1in-fot{
    display: flex;
    align-items: center;
    padding: 10px 0;
    padding-left: 90px;
}
.lke-tab1in-fot > span{
    font-size: 16px;
    color: #888888;
    padding-right: 50px;
}
.lke-tab1in-fot > div{
    flex: 1;
}
.lke-fot{
    width: 1024px;
    border-top: 1px dashed #ccc;
    padding: 10px 0 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/wdkc/wdkc.vue